import script from "./search.vue?vue&type=script&lang=ts&setup=true"
export * from "./search.vue?vue&type=script&lang=ts&setup=true"

import "./search.vue?vue&type=style&index=0&id=3bdd7bc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bdd7bc0"]])

export default __exports__